( function ( $ ) {
    // Initialize Slidebars
    var controller = new slidebars();
    controller.init();


    // Toggle Slidebars
    $( '[data-offcanvas-menu-toggle]' ).on( 'click', function ( event ) {
        // Stop default action and bubbling
        event.stopPropagation();
        event.preventDefault();

        var toggleID = $(this).attr('data-offcanvas-menu-toggle' );

        // Toggle the slidebar
        controller.toggle( toggleID );

        // Initialize the exit function
        initExitFunction( controller.getActiveSlidebar() );
    } );


    // When the sidebar is open, allow the user to click anywhere in the main canvas to close the slidebar
    function initExitFunction( $slidebar ) {
        $( '[canvas="container"]').on( 'click', function( event ) {
            // Close any slidebars
            controller.close( $slidebar );
        } );
    }

} ) ( jQuery );